import { render, staticRenderFns } from "./ClientZone.vue?vue&type=template&id=a4a42e3a&"
import script from "./ClientZone.vue?vue&type=script&lang=js&"
export * from "./ClientZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports